export default __webpack_public_path__ + "static/MediaContentFour-75928d84dd9b4220e0383f388f573909.webp";